import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import CopyrightText from '../../components/much-text/CopyrightText'
import React, { useEffect } from 'react'
import { Formik } from 'formik'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import * as Yup from 'yup'
import Typography from '@mui/material/Typography'
import LinkMUI from '@mui/material/Link'
import Dialog from '@mui/material/Dialog'
import { Box, useTheme } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import useClasses from '../../components/hooks/UseClasses'
import { useTranslation } from 'react-i18next'
import config from '@/config/env'
import { useEmbeddedMessaging } from '@/components/app-context/EmbeddedMessagingContext'

const { CRISP_CHAT, SF_ENABLED } = config

const styles = (theme) => ({
  card: {
    backgroundColor: theme.palette.background.white.color,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  imagen: {
    width: '10rem',
    margin: '0.75rem 3rem',
  },
  pop: {
    paddingTop: '2rem',
    backgroundColor: theme.palette.primary.main + ' !important',
    color: 'white !important',
  },
  footer: {
    padding: '1rem',
    backgroundColor: theme.palette.background.primary.color,
  },
})

const LoginForm = ({ ...props }) => {
  const [phonePop, setPhonePop] = React.useState(false)
  const tel = '+34919032923'
  const theme = useTheme()
  const classes = useClasses(styles)
  const { t } = useTranslation()
  const em = useEmbeddedMessaging()

  if (CRISP_CHAT !== undefined && CRISP_CHAT === 'true') {
    $crisp.push(['safe', true])
    $crisp.push(['do', 'chat:hide'])
  }

  useEffect(() => {
    if (SF_ENABLED !== undefined && SF_ENABLED === 'true') {
      em.hide()
    }
  }, [em])

  return (
    <Paper className={classes.card} elevation={5}>
      <img className={classes.imagen} src={props.standard ? '/assets/tmp.jpg' : '/assets/loginform_massol.png'} />
      <Formik
        initialValues={{ user: '', password: '' }}
        onSubmit={props.onSigin}
        validationSchema={Yup.object().shape({
          user: Yup.string().email(t('LOGIN.MAILFORMAT')).required(t('LOGIN.REQUIRED.MAIL')),
          password: Yup.string().required(t('LOGIN.REQUIRED.PASSWORD')),
        })}>
        {({ values, handleChange, handleSubmit, isSubmitting, errors, touched }) => (
          <form onSubmit={handleSubmit} style={{ marginTop: '0.5rem', width: '100%', textAlign: 'center' }}>
            <Grid size={12} style={{ display: 'grid', width: '100%', gap: '1rem' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="user"
                label={t('LOGIN.USER')}
                name="user"
                autoComplete="user"
                autoFocus
                value={values.user}
                helperText={touched.user && errors.user}
                error={Boolean(touched.user && errors.user)}
                onChange={handleChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="password"
                label={t('LOGIN.PASSWORD')}
                name="password"
                type="password"
                autoComplete="current-password"
                helperText={touched.password && errors.password}
                error={Boolean(touched.password && errors.password)}
                onChange={handleChange}
              />
              <Box size={12} style={{ justifyContent: 'right' }}>
                <LinkMUI onClick={() => setPhonePop(true)} underline="hover">
                  <Typography
                    variant="caption_medium"
                    style={{
                      color: theme.palette.text.success.color,
                      cursor: 'pointer',
                    }}>
                    {t('LOGIN.FORGOT.PASSWORD')}
                  </Typography>
                </LinkMUI>
              </Box>
              <Dialog onClose={() => setPhonePop(false)} open={phonePop}>
                <Paper className={classes.pop}>
                  <Grid container>
                    <Grid size={12} style={{ padding: '1rem 2rem' }}>
                      <Typography align="justify" style={{ color: theme.palette.text.light.color }}>
                        {t('LOGIN.CALLIFFORGOT')} <b>{tel}</b>
                      </Typography>
                    </Grid>
                    <Grid className={classes.footer} size={12}>
                      <LinkMUI color="white.main" href={'tel:' + tel} underline="hover">
                        <Typography className={'centerAlign'} style={{ color: theme.palette.text.light.color }}>
                          <PhoneIcon
                            style={{
                              marginRight: '4px',
                            }}
                            fontSize="medium"
                          />
                          {t('HEADER.CALL')}
                        </Typography>
                      </LinkMUI>
                    </Grid>
                  </Grid>
                </Paper>
              </Dialog>
              <Button
                disabled={isSubmitting && !props.errors}
                variant="mediumPrimary"
                style={{ width: '100%', placeSelf: 'center' }}
                type="submit">
                {t('LOGIN.BUTTON.SIGIN')}
              </Button>
              {props.errors && (
                <Alert severity="error">
                  <AlertTitle>Oh oh...</AlertTitle>
                  {t('LOGIN.ERROR')}
                </Alert>
              )}
              <CopyrightText standard={props.standard} />
            </Grid>
          </form>
        )}
      </Formik>
    </Paper>
  )
}

export default LoginForm
